import { render, staticRenderFns } from "./CadastroLicenciada.vue?vue&type=template&id=2db15370&scoped=true&"
import script from "./CadastroLicenciada.vue?vue&type=script&lang=js&"
export * from "./CadastroLicenciada.vue?vue&type=script&lang=js&"
import style0 from "./CadastroLicenciada.vue?vue&type=style&index=0&id=2db15370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db15370",
  null
  
)

export default component.exports